<template>
    <div class="row">
        <div class="col-12">
            <div class="multisteps-form">
                <div class="row">
                    <div class="col-12 col-lg-12 mb-2">
                        <div class="card">
                            <div class="card-body">
                                <div class="multisteps-form__progress">
                                    <button v-for="(step, index) in formSteps" :key="index" disabled
                                        class="multisteps-form__progress-btn" type="button" :title="step.title"
                                        :class="activeStep >= index ? activeClass : ''" @click="activeStep = index">
                                        <span class="size-span">{{ step.title }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--form panels-->
                <div class="row">
                    <div class="col-12 col-lg-12">
                        <form class="multisteps-form__form">
                            <component :is="currentComponent" :class="activeStep === currentIndex ? activeClass : ''"
                                @next-step="nextStep" @prev-step="prevStep" :schedulingConfig="schedulingConfig" />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import Scheduled from "./components/Scheduled.vue";
import { defineAsyncComponent } from "vue";

const activeClass = "js-active position-relative";
const activeStep = ref(0);
const formSteps = [
    { title: "Agendamentos" },
    { title: "Dia da Visita" },
    { title: "Horários" },
    { title: "Acompanhantes" },
    { title: "Confirmação" }
];
const schedulingConfig = ref();

const Calendar = defineAsyncComponent(() => import("./components/Calendar.vue"));
const Hours = defineAsyncComponent(() => import("./components/Hours.vue"));
const Visitants = defineAsyncComponent(() => import("./components/Visitants.vue"));
const Confirmation = defineAsyncComponent(() => import("./components/Confirmation.vue"));

const components = [Scheduled, Calendar, Hours, Visitants, Confirmation];

const currentIndex = ref(0);

const currentComponent = ref(components[0]);

const nextStep = (data) => {
    schedulingConfig.value = data;
    if (activeStep.value < formSteps.length) {
        activeStep.value += 1;
        currentIndex.value += 1;
        currentComponent.value = components[currentIndex.value];
    }
};
const prevStep = (data) => {
    schedulingConfig.value = data;
    if (activeStep.value > 0) {
        activeStep.value -= 1;
        currentIndex.value -= 1;
        currentComponent.value = components[currentIndex.value];
    }
};


</script>

<style>
.square {
    width: 1500px;
    height: 500px;
    transform: scale(0.9);
}

.vc-week {
    padding-top: 40px;
}

.size-span {
    font-size: 12px;
}
</style>
